import React from 'react';
import loadable from '@loadable/component';

export const AsyncFAQsLayout = loadable(() => import(/* webpackPrefetch: true */ './FAQsLayout'));

const FAQsLayout = (props) => <AsyncFAQsLayout {...props} />;

export default FAQsLayout;
